import React, { useEffect, useState } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import { Add, Delete, Visibility } from '@material-ui/icons';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import { Link, useNavigate } from 'react-router-dom';
import { wsGetAll, wsRemove } from 'services/WService';
import ButtonDelete from 'hooks/ButtonDelete';
import { wsFindBy } from 'services/WService';
import FilterCustom from 'components/Tvendo/Common/FilterCustom';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 115 },
  { Header: 'Estado', accessor: 'state_migrate', width: 120 },
  { Header: 'Estado SAP', accessor: 'u_syp_status', width: 120 },
  { Header: 'Proveedor', accessor: 'CardName' },
  { Header: 'Documento', accessor: 'document', width: 120 },
  { Header: 'Referencia', accessor: 'purchase', width: 120 },
  { Header: 'Total', accessor: 'DocTotal', width: 150 },
  { Header: 'Fecha creación', accessor: 'created_at', width: 150 },
  { Header: 'Fecha documento', accessor: 'TaxDate', width: 170 },
  { Header: 'Fecha contable', accessor: 'DocDate', width: 170 },
  { Header: 'Fecha vencimiento', accessor: 'DocDueDate', width: 170 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function PurchaseCreditNoteList() {
  const navigate = useNavigate();
  const [creditNotes, setCreditNotes] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  async function listCreditNotes(filter) {
    setDataLoading(true);
    let res = await wsFindBy('purch/credit-note', filter);
    setDataLoading(false);
    if (res.success) {
      setCreditNotes(res.data);
    }
  }

  async function processCancelCreditNote(creditNoteId) {
    if (!window.confirm('¿Seguro de anular la nota de crédito?\nEsta acción no es reversible')) return;
    setDataLoading(true);
    const res = await wsRemove('purch/credit-note', creditNoteId);
    setDataLoading(false);
    if (res.success) {
      window.alert(res.message);
    } else {
      window.alert(`Error: ${res.message}`);
    }
  }

  // useEffect(() => {
  //   listCreditNotes();
  // }, []);

  return (
    <CardContainer /*title="Notas de crédito compras"*/ title={(<>Notas de crédito compras {dataLoading && <LoadingSpinner />}</>)} icon={<Add />} onClick={() => {
      navigate('0');
    }}>
      <FilterCustom
        getFilter={listCreditNotes}
        dateRange
        diffRange={7}
        provider
        typePurchCreditNote
        typePurchCreditNoteSap
      />
      <ReactTable
        columns={columns}
        formatDate="DD-MM-YYYY"
        data={creditNotes.map((creditNote, index) => {
          let state_migrate = creditNote.state_migrate;
          switch (creditNote.state_migrate) {
            case 'D':
              state_migrate = 'Borrador';
              break;
            case 'V':
              state_migrate = 'Validado';
              break;
            case 'X':
              state_migrate = 'Procesando...';
              break;
            case 'P':
            case 'Y':
              state_migrate = 'Procesado';
              break;
          }
          let u_syp_status = creditNote.orpc?.u_syp_status;
          switch (u_syp_status) {
            case 'V':
              u_syp_status = 'Vigente';
              break;
            case 'A':
              u_syp_status = 'Anulado SUNAT';
              break;
            case 'I':
              u_syp_status = 'Anulado Interno';
              break;
            default:
              u_syp_status = 'Sin estado definido';
          }

          return {
            num: (
              <div className="actions-right">
                {index + 1}
                <Link to={`${creditNote.id}`} disabled={dataLoading}>
                  <Visibility />
                </Link>
                <RegularButton
                  justIcon simple round color="danger"
                  onClick={() => processCancelCreditNote(creditNote.id)}
                  disabled={dataLoading || creditNote.state_migrate !== 'Y' && creditNote.sapAnnuled === null}
                >
                  <Delete />
                </RegularButton>
                <AllowedGuard permission={ConstantPermissions.PURCH_PURCHASES_DELETED}>
                  <ButtonDelete
                    entity="purch/credit-note-eliminar"
                    id={creditNote.id}
                    reload={() => listCreditNotes()}
                  />
                </AllowedGuard>
              </div>
            ),
            state_migrate,
            u_syp_status,
            CardName: creditNote.provider.CardName,
            document: `${creditNote.U_SYP_MDSD}-${creditNote.U_SYP_MDCD}`,
            purchase: `${creditNote.U_SYP_MDSO}-${creditNote.U_SYP_MDCO}`,
            DocTotal: creditNote.DocTotal,
            created_at: creditNote.created_at,
            TaxDate: creditNote.TaxDate,
            DocDate: creditNote.DocDate,
            DocDueDate: creditNote.DocDueDate,
          };
        })}
      />
    </CardContainer>
  );
}

export default PurchaseCreditNoteList;
